export interface CreateBibliographySearchDetailListRequestItem {
  prefix: string
  bibliographyId: number
  shelfTypeName: string
  callNo: string
  collectionState: string
  collectionNo: string
  handlingTypeName: string
  collectionStatusName: string
  shelfCount: string | undefined
  holdingCount: string | undefined
  orderCount: string | undefined
  reserveCount: string | undefined
}

export interface CreateBibliographySearchDetailListRequest {
  bibliographies: CreateBibliographySearchDetailListRequestItem[]
}

export function CreateBibliographySearchDetailListRequestToJSON(
  value: CreateBibliographySearchDetailListRequest
): any {
  return {
    bibliographies: value.bibliographies.map(item => {
      return {
        prefix: item.prefix,
        bibliography_id: item.bibliographyId,
        shelf_type_name: item.shelfTypeName,
        call_no: item.callNo,
        collection_state: item.collectionState,
        collection_no: item.collectionNo,
        handling_type_name: item.handlingTypeName,
        collection_status_name: item.collectionStatusName,
        shelf_count: item.shelfCount,
        holding_count: item.holdingCount,
        order_count: item.orderCount,
        reserve_count: item.reserveCount
      }
    })
  }
}
